<template>
    <div>
        <a
            href="#"
            @click="display=true"
        >
            <slot></slot>
        </a>
        <div class="photo-enlarged" v-if="display">
            <!-- Header -->
            <div class="panel-header">
                <!-- Close icon -->
                <icon-close :id="'image-viewer-close'"
                            @close="display=false"
                            class="d-inline-block float-right">
                </icon-close>
            </div>
            <!-- Content -->
            <div class="photo-content">
                <a id="object_image_rotate" v-show="!isSmallDevice" class="rotate-white-icon" @click.stop="$_rotate($event, (rotate + 90))"></a>
                <div class="imagecontainer">
                    <div ref="preview" class="image-preview-area">
                        <img :src="src" :alt="alt" :style="imageStyle" />
                    </div>
                    <p class="viewer_info">Klik op Openen om te openen in een nieuw venster/tabblad voor afdrukken/opslaan.</p>
                    <div><a class="open_tab_button" :href="src" target="_blank">Openen</a></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import IconClose from '../IconClose.vue';
    import { isSmallDevice } from '../../services/utilities/devices';

    export default {
        components: { 'icon-close': IconClose, },
        props: {
            src: { type: String, required: true  },
            alt: { type: String, default: 'Niet beschikbaar'  },
        },
        data() {
            return {
                rotate: 0,
                display: false,
                enlargedSrc: '',
                isSmallDevice: isSmallDevice(),
                // standard width and height of ref=preview
                imageWidth: isSmallDevice() ? 400: 748,
                imageHeight: isSmallDevice() ? 525: 464
            };
        },
        computed: {
            imageStyle() {
                // Scale correctly
                const cssRotateDeg = `rotate(${this.rotate}deg)`;
                let height = this.imageHeight;
                let width = this.imageWidth;
                return {
                    WebkitTransform: cssRotateDeg,
                    msTransform: cssRotateDeg,
                    transform: cssRotateDeg,
                    'max-height': !isSmallDevice() ? `${height}px`: '',
                    'max-width': isSmallDevice() ? `${width}px`: ''
                };
            }
        },
        methods: {
            $_rotate(event, rotate) {
                const previewImage = this.$refs.preview;
                // Rotate
                if (rotate !== 0) {
                    // 360 is complete rotation
                    if (rotate === 360) {
                        rotate = 0;
                    }
                    this.rotate = rotate;
                }
                // Get actual dimensions
                this.imageWidth = previewImage.clientWidth;
                this.imageHeight = previewImage.clientHeight;
            }
        }
    };
</script>

<style scoped>
    .open_tab_button {
        display: inline-block;
        padding: 4px 10px;
        color: #fff;
        background-color: #007AC9;
        z-index: 3;
    }

    .image-preview-area {
        display: flex;
        align-items: center;
        justify-content: center;
        align-content: center;
        overflow: hidden; /* Prevents unwanted scrollbars */
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
    }

    #object_image_rotate {
        position: absolute;
        top: 1em;
        left: 1em;
        background-color: #007AC9;
        color: white;
        border-radius: 100%;
        width: 30px;
        height: 30px;
        display: block;
        padding-top: 7px;
        text-align: center;
        cursor: pointer;
        z-index: 2;
    }

    .photo-enlarged {
        position: fixed;
        width: 750px;
        height: 600px;
        left: 50%;
        margin-left: -375px;
        top: 50%;
        margin-top: -300px;
        background: #ffffff;
        border: 1px solid #cdcdcd;
        z-index: 12000;
        white-space: pre-wrap;
        cursor: default;
    }

    .photo-enlarged .photo-content {
        position: relative;
        height: calc(100% - 40px);
    }

    .photo-enlarged .viewer_info {
        font-size: 14px;
    }

    .photo-enlarged .imagecontainer {
        padding-top: 10px;
        height: calc(100% - 20px);
        text-align: center;
        display: flex;
        flex-direction: column;
    }

    .photo-enlarged .imagecontainer img {
        border-radius: 3px;
        max-width: 500px;
        max-height: 500px;
        display: inline-block;
        margin-left: auto;
        margin-right: auto;
        margin-top: auto;
        margin-bottom: auto;
        transform-origin: center center;
    }
    /*-------------------------------------
    max-width : 767px
    ---------------------------------------*/
    @media (max-width : 767px) {
        .photo-enlarged {
            width: 100%;
            height: calc(100% - var(--paneltop));
            margin: 0;
            top: var(--paneltop);
            left: 0;
        }
    }
</style>
